import { render } from "./Navbar.vue?vue&type=template&id=8565e8ee&lang=pug"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=8565e8ee&lang=scss"
script.render = render

export default script